import NextLink from '@/components/NextLink';
import { useItineraryMapStore } from '@/core/stores/itinerary';
import { useItineraryStoreV2 } from '@/core/stores/itinerary/itineraryV2';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import useSizeController from '@/hooks/useSizeController';
import { generateColor } from '@/utils/generateColor';
import { faCheck, faX } from '@fortawesome/pro-regular-svg-icons';
import { faBed } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import Link from 'next/link';
import { Dispatch, SetStateAction } from 'react';




export default function MapOptions({ showDays, setShowDays }: { showDays: boolean, setShowDays: Dispatch<SetStateAction<boolean>> }) {
    const { itineraryDays, setActiveDays, activeDays, baseUrl } = useItineraryStoreV2()
    const { setShowHotels, showHotels, totalHotelsCount } = useItineraryMapStore()
    const { isSmall } = useSizeController()

    const ref = useOutsideClick(() => { !isSmall && setShowDays(false) })


    // useEffect(() => {
    //     const filteredData = activitiyFilters === 'all' ? activities : activities?.filter(item => item.types.includes(activitiyFilters));
    //     const searched = filterHotelsByName(searchActivity, filteredData)
    //     setFilteredActivity(searched)
    // }, [activitiyFilters, activities, setFilteredActivity, searchActivity])

    const onChangeDay = (day: number) => {
        if (activeDays.includes(day)) {
            setActiveDays(activeDays.filter((d) => d !== day))
        } else {
            setActiveDays([...activeDays, day]);
        }
    };
    return (
        <>
            {showDays && <div onClick={() => setShowDays(false)} className='fixed md:hidden z-20 top-0 left-0  h-dvh w-dvw'>

            </div>}

            <AnimatePresence>
                {showDays && <motion.div
                    ref={ref}
                    initial={{ opacity: 0 }}
                    exit={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    className={`
                 mt-1 flex shadow absolute translate-y-full z-30 w-fit flex-col bottom-10
                  min-w-64 right-12 gap-2 rounded-3xl bg-white py-4 px-4 transition-all`}
                >

                    <div>
                        <div className='flex items-center justify-between'>

                            <p className='text-gray-900 font-semibold mb-2'>Show/Hide Your Plan</p>
                            <FontAwesomeIcon
                                icon={faX}
                                size='xs'
                                onClick={() => setShowDays(false)}
                                className='size-3 text-xs cursor-pointer flex items-center 
                                        justify-center hover:bg-gray-100 rounded-md p-1 text-neutral-300'
                            />
                        </div>
                        <div className='flex flex-col gap-1'>
                            <span className='text-sm font-semibold'>Itinerary Items</span>
                            {itineraryDays.length > 0 ? itineraryDays.map((day, index) => (
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        onChangeDay(index)
                                    }}
                                    key={day.id}
                                    className={`grid  py-1 grid-cols-[20px,_1fr,_20px] items-center gap-2`}
                                >
                                    <svg className={` relative w-5`} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" >

                                        <path d="M18 21.9994C18 23.5907 18.6321 25.1168 19.7574 26.2421C20.8826 27.3673 22.4087 27.9994 24 27.9994C25.5913 27.9994 27.1174 27.3673 28.2426 26.2421C29.3679 25.1168 30 23.5907 30 21.9994C30 20.4081 29.3679 18.882 28.2426 17.7568C27.1174 16.6316 25.5913 15.9994 24 15.9994C22.4087 15.9994 20.8826 16.6316 19.7574 17.7568C18.6321 18.882 18 20.4081 18 21.9994Z"
                                            fill={generateColor(index + 1)} />
                                        <path d="M35.314 33.3134L26.828 41.7994C26.078 42.5487 25.0612 42.9696 24.001 42.9696C22.9408 42.9696 21.924 42.5487 21.174 41.7994L12.686 33.3134C10.4484 31.0757 8.92468 28.2248 8.30738 25.1211C7.69009 22.0175 8.00699 18.8004 9.21801 15.8769C10.429 12.9533 12.4798 10.4545 15.111 8.69643C17.7421 6.93836 20.8355 6 24 6C27.1645 6 30.2579 6.93836 32.889 8.69643C35.5202 10.4545 37.571 12.9533 38.782 15.8769C39.993 18.8004 40.3099 22.0175 39.6926 25.1211C39.0753 28.2248 37.5516 31.0757 35.314 33.3134Z" fill={generateColor(index + 1)} />
                                        <path d="M35.314 33.3134L35.8443 33.8437L35.8444 33.8437L35.314 33.3134ZM26.828 41.7994L27.3581 42.33L27.3583 42.3297L26.828 41.7994ZM21.174 41.7994L20.6437 42.3298L20.6439 42.33L21.174 41.7994ZM12.686 33.3134L12.1557 33.8437L12.1557 33.8438L12.686 33.3134ZM17.25 21.9994C17.25 23.7896 17.9612 25.5065 19.227 26.7724L20.2877 25.7117C19.3031 24.7272 18.75 23.3918 18.75 21.9994H17.25ZM19.227 26.7724C20.4929 28.0383 22.2098 28.7494 24 28.7494V27.2494C22.6076 27.2494 21.2723 26.6963 20.2877 25.7117L19.227 26.7724ZM24 28.7494C25.7902 28.7494 27.5071 28.0383 28.773 26.7724L27.7123 25.7117C26.7278 26.6963 25.3924 27.2494 24 27.2494V28.7494ZM28.773 26.7724C30.0388 25.5065 30.75 23.7896 30.75 21.9994H29.25C29.25 23.3918 28.6969 24.7272 27.7123 25.7117L28.773 26.7724ZM30.75 21.9994C30.75 20.2092 30.0388 18.4923 28.773 17.2264L27.7123 18.2871C28.6969 19.2717 29.25 20.607 29.25 21.9994H30.75ZM28.773 17.2264C27.5071 15.9606 25.7902 15.2494 24 15.2494V16.7494C25.3924 16.7494 26.7278 17.3025 27.7123 18.2871L28.773 17.2264ZM24 15.2494C22.2098 15.2494 20.4929 15.9606 19.227 17.2264L20.2877 18.2871C21.2723 17.3025 22.6076 16.7494 24 16.7494V15.2494ZM19.227 17.2264C17.9612 18.4923 17.25 20.2092 17.25 21.9994H18.75C18.75 20.607 19.3031 19.2717 20.2877 18.2871L19.227 17.2264ZM34.7837 32.7831L26.2977 41.2691L27.3583 42.3297L35.8443 33.8437L34.7837 32.7831ZM26.2979 41.2688C25.6885 41.8776 24.8624 42.2196 24.001 42.2196V43.7196C25.26 43.7196 26.4674 43.2198 27.3581 42.33L26.2979 41.2688ZM24.001 42.2196C23.1396 42.2196 22.3135 41.8776 21.7041 41.2688L20.6439 42.33C21.5346 43.2198 22.7421 43.7196 24.001 43.7196V42.2196ZM21.7043 41.269L13.2163 32.783L12.1557 33.8438L20.6437 42.3298L21.7043 41.269ZM13.2164 32.7831C11.0837 30.6503 9.63134 27.933 9.04297 24.9748L7.57179 25.2674C8.21802 28.5166 9.81322 31.5012 12.1557 33.8437L13.2164 32.7831ZM9.04297 24.9748C8.45461 22.0167 8.75666 18.9504 9.91092 16.1639L8.52511 15.5899C7.25731 18.6505 6.92556 22.0183 7.57179 25.2674L9.04297 24.9748ZM9.91092 16.1639C11.0652 13.3774 13.0198 10.9957 15.5276 9.32003L14.6943 8.07282C11.9398 9.9133 9.7929 12.5292 8.52511 15.5899L9.91092 16.1639ZM15.5276 9.32003C18.0355 7.64438 20.9839 6.75 24 6.75V5.25C20.6872 5.25 17.4488 6.23235 14.6943 8.07282L15.5276 9.32003ZM24 6.75C27.0161 6.75 29.9645 7.64438 32.4724 9.32003L33.3057 8.07282C30.5512 6.23235 27.3128 5.25 24 5.25V6.75ZM32.4724 9.32003C34.9802 10.9957 36.9348 13.3774 38.0891 16.1639L39.4749 15.5899C38.2071 12.5292 36.0602 9.9133 33.3057 8.07282L32.4724 9.32003ZM38.0891 16.1639C39.2434 18.9504 39.5454 22.0167 38.957 24.9748L40.4282 25.2674C41.0745 22.0183 40.7427 18.6505 39.4749 15.5899L38.0891 16.1639ZM38.957 24.9748C38.3687 27.933 36.9163 30.6503 34.7837 32.7831L35.8444 33.8437C38.1868 31.5012 39.782 28.5166 40.4282 25.2674L38.957 24.9748Z"
                                            fill={generateColor(index + 1)} />
                                    </svg>
                                    <span className='text-sm text-left text-gray-600 '>Day {index + 1}</span>
                                    <span className='size-5 flex text-secondary-500 items-center justify-center 
                                                    rounded-md border border-secondary-500'
                                    >
                                        {activeDays.includes(index) && <FontAwesomeIcon icon={faCheck} />}
                                    </span>
                                </button>
                            )) :
                                <Link href={`${baseUrl}/edit`} className='text-center text-secondary-500'>Add a day!</Link>
                            }

                        </div>
                        <div className='flex border-t mt-4 pt-4 flex-col gap-1'>
                            <span className='text-sm font-semibold'>Places Items</span>
                            <button onClick={() => setShowHotels(!showHotels)} className={`grid py-1 grid-cols-[20px,_1fr,_20px] items-center gap-2`}>
                                <FontAwesomeIcon className='text-main-500' icon={faBed} />
                                <span className='text-sm text-left text-gray-900'>
                                    Hotels <span className='text-gray-500 text-xs font-normal'>({totalHotelsCount})</span>
                                </span>
                                <span className='size-5 flex text-secondary-500 items-center justify-center 
                                                    rounded-md border border-secondary-500'
                                >
                                    {showHotels && <FontAwesomeIcon icon={faCheck} />}
                                </span>
                            </button>
                        </div>
                    </div>

                    {/* <div className='mt-3'>
                    <p className='text-xs text-gray-550 font-semibold mb-2'>Activities</p>
                    <div className='grid grid-cols-3 gap-2'>
                        {activitiesFilters.map((item, index) => (
                            <button
                                onClick={() => {
                                    if (activitiyFilters === item.type) {
                                        setShowActivities(!showActivities)
                                    }
                                    setActivityFilter(item.type)
                                }}
                                key={item.type}
                                className={`${((activitiyFilters === item.type) && showActivities) ?
                                    'bg-black text-white' :
                                    'bg-white text-gray-600'} w-full max-w-14 max-h-14 flex flex-col gap-1 justify-around items-center p-1 aspect-square border rounded-xl border-gra`}>
                                {filterIcons[item.type]}
                                <span className='text-[10px]  font-semibold capitalize'>{item.title}</span>
                            </button>
                        ))}

                    </div>
                </div> */}

                </motion.div>}
            </AnimatePresence>
        </>
    );
}
